module.exports = __webpack_public_path__ + "static/media/cust-admin-table.c082d56f.png";